import { userService } from "./userService";

const API_URL = process.env.REACT_APP_API_URL;

export const aiService = {
  // ... your existing functions ...

  // =============================
  // ===== PENDING ENTRIES =====
  // =============================
  async getPendingEntries(userId) {
    try {
      const url = `${API_URL}/api/pending-entries`;
      let response = await fetch(url, { headers: userService._getAuthHeaders() });

      if (response.status === 401) {
        const newToken = await userService.refreshAccessToken();
        if (newToken) {
          response = await fetch(url, { headers: userService._getAuthHeaders() });
        } else {
          throw new Error("Session expired. Please log in again.");
        }
      }

      if (!response.ok) throw new Error("Failed to fetch pending entries");
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error("Error fetching pending entries:", error);
      return {
        pendingEntries: [],
        summary: {
          totalPendingEntries: 0,
          totalPendingAmount: 0,
          riskDistribution: { high: 0, medium: 0, low: 0 },
          byType: { lba: 0, lpd: 0, lawFirm: 0 }
        },
        entriesByType: {
          lpdEntries: [],
          lbaEntries: [],
          lawFirmEntries: []
        }
      };
    }
  },

  async getHighRiskPendingEntries(userId) {
    try {
      const url = `${API_URL}/api/pending-entries/high-risk`;
      let response = await fetch(url, { headers: userService._getAuthHeaders() });

      if (response.status === 401) {
        const newToken = await userService.refreshAccessToken();
        if (newToken) {
          response = await fetch(url, { headers: userService._getAuthHeaders() });
        } else {
          throw new Error("Session expired. Please log in again.");
        }
      }

      if (!response.ok) throw new Error("Failed to fetch high-risk pending entries");
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error("Error fetching high-risk pending entries:", error);
      return {
        highRiskPendingEntries: [],
        count: 0,
        summary: { high: 0, medium: 0 }
      };
    }
  }
};